import { render, staticRenderFns } from "./HomeDividerText.vue?vue&type=template&id=06fd5a3a&scoped=true&"
import script from "./HomeDividerText.vue?vue&type=script&lang=js&"
export * from "./HomeDividerText.vue?vue&type=script&lang=js&"
import style0 from "./HomeDividerText.vue?vue&type=style&index=0&id=06fd5a3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd5a3a",
  null
  
)

export default component.exports